import React  from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

import styles from './index.module.css';
import BLOCKS from '@store/blocks';

import comm from '@utils/comm';

import Button from '@components/common/button';
import ScrollBlock from "@components/common/scroll-block";

import { SHIFT_STEP, BEGIN_RECON } from './actions';
import { UPDATE_BALANCE } from '@components/containers/user-info-block/actions';

import Block, {LOCATIONS} from '@components/common/block';
import DATA from '@constants/test.json';

import muniGovt1 from '@images/locations/image 201.jpg';
import waterTower1 from '@images/locations/image 162.jpg';
import btex1 from '@images/locations/image 158.jpg';
import firnFreeze1 from '@images/locations/image 152.jpg';
import kilroys1 from '@images/locations/image 181.jpg';
import pluckers1 from '@images/locations/image 219.jpg';
import LossLane from '@images/locations/image 165.jpg';
import selfLume1 from '@images/locations/image 193.jpg';
import fallowHome1 from '@images/locations/image 145.jpg';
import kameKondos1 from '@images/locations/image 139.jpg';
import selfLume2 from '@images/locations/image 190.jpg';
import tillies1 from '@images/locations/image 213.jpg';
import SelfLume_ClearedZone from '@images/locations/image 171.jpg';
import SelfLume_EastWall from '@images/locations/image 174.jpg';
import fourHomes1 from '@images/locations/image 223.jpg';
import vinyards1 from '@images/locations/image 187.jpg';
import eolianAcres1 from '@images/locations/image 149.jpg';
import townWell1 from '@images/locations/image 197.jpg';
import ScrubBushes from '@images/locations/image 168.jpg';

const imgInnerOuterCorrespondence = {
  "muniGovt1": muniGovt1,
  "waterTower1": waterTower1,
  "btex1": btex1,
  "firnFreeze1": firnFreeze1,
  "kilroys1": kilroys1,
  "pluckers1": pluckers1,
  "LossLane": LossLane,
  "selfLume1": selfLume1,
  "fallowHome1": fallowHome1,
  "kameKondos1": kameKondos1,
  "selfLume2": selfLume2,
  "tillies1": tillies1,
  "SelfLume_ClearedZone": SelfLume_ClearedZone,
  "SelfLume_EastWall": SelfLume_EastWall,
  "fourHomes1": fourHomes1,
  "vinyards1": vinyards1,
  "eolianAcres1": eolianAcres1,
  "townWell1": townWell1,
  "ScrubBushes": ScrubBushes
};


function InitialStep(props) {
  return (<Block
    header='Instructions'
    location={LOCATIONS.TOP}
    className={`${styles.block} ${styles.initBlock}`}>
    <ScrollBlock className={styles.scrollBlock}>{DATA.reconGreeting}</ScrollBlock>
    <div className={styles.bottomBlock}>
      <div className={styles.text}>Visual Reconnaissance:</div>
      <Button onClick={props.onStart} disabled={props.started} className={styles.beginButton}>Begin</Button>
    </div>

  </Block>);
}

InitialStep.propTypes = {
  onStart: PropTypes.func.isRequired,
  started: PropTypes.bool.isRequired
};

function FurtherStep(props) {
  return (<Block
    header='Journal Notes'
    location={LOCATIONS.TOP}
    className={`${styles.block} ${styles.furtherBlock}`}>
    <img src={props.imgSrc in imgInnerOuterCorrespondence ? imgInnerOuterCorrespondence[props.imgSrc] : ""}
      alt="An image depicting the location" />
    <ScrollBlock className={styles.scrollBlock}>{props.notes}</ScrollBlock>
    <div className={styles.navBlock}>
      <Button className={styles.button} onClick={props.stepBack} disabled={!props.canMoveBackward}>Back</Button>
      <Button className={styles.button} onClick={props.stepForward} disabled={!props.canMoveForward}>Continue</Button>
    </div>
  </Block>);
}

FurtherStep.defaultProps = {
  canMoveForward: false,
  canMoveBackward: false
};

FurtherStep.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  notes: PropTypes.string.isRequired,
  stepBack: PropTypes.func.isRequired,
  stepForward: PropTypes.func.isRequired,
  canMoveForward: PropTypes.bool,
  canMoveBackward: PropTypes.bool
};








class ReconPanelsBlock extends React.Component {

  constructor(props) {
    super(props);

    this.stepForward = this.props.dispatch.bind(null, SHIFT_STEP, 1);
    this.stepBack = this.props.dispatch.bind(null, SHIFT_STEP, -1);

    this.onStart = this.onStart.bind(this);

    this.lastStep = comm.dataStore.recon.length - 1;
    this.firstStep = 0;
  }

  onStart() {

    this.props.dispatch(BEGIN_RECON);

    //navObj.controls_mc.enable(false);
    this.stepForward();
    comm.dataStore.saveRecon(100);
    //navObj.updateBalance();
    comm.dataStore.saveReceivedDocument("recon");
    this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
  }

  render() {
    let props = this.props;

    let currentStep = props.currentStep;
    let notes;
    let img;

    if (currentStep >= this.firstStep && currentStep <= this.lastStep) {
      notes = comm.dataStore.recon[currentStep].notes;
      img = comm.dataStore.recon[currentStep].picName;
    }

    return (<React.Fragment>
      <InitialStep started={currentStep >= this.firstStep} onStart={this.onStart} />
      {props.currentStep >= this.firstStep &&
        <FurtherStep
          imgSrc={img}
          notes={notes}
          canMoveForward={currentStep < this.lastStep}
          canMoveBackward={currentStep > this.firstStep}
          stepBack={this.stepBack}
          stepForward={this.stepForward} />}
      {props.currentStep < this.firstStep &&
        <Block className={`${styles.block} ${styles.furtherBlock}`}
          location={LOCATIONS.TOP} />}
    </React.Fragment>);
  }
}

ReconPanelsBlock.propTypes = {
  currentStep: PropTypes.number.isRequired
};

export default branch({
  currentStep: BLOCKS.RECON_PANELS.CURRENT_STEP
}, ReconPanelsBlock);